module.exports = __webpack_public_path__ + "media/images/regional-image3-a3af2e2c907e000770665a9c847180fb.jpg";